import { CurveType } from '../enums';

export const TORQUE_OVER_SPEED_DIAGRAM_CURVES = [
    CurveType.TorqueOverSpeed,
    CurveType.TorqueOverSpeedWithSpecificVoltage,
    CurveType.Load,
    CurveType.LimitCurve,
    CurveType.AccelerationTorque,
    CurveType.AccelerationTorqueWithSpecificVoltage,
    CurveType.DolStarDeltaTorque
];
export const CURRENT_OVER_SPEED_DIAGRAM_CURVES = [CurveType.CurrentOverSpeed, CurveType.CurrentOverSpeedWithSpecificVoltage, CurveType.DolStarDeltaCurrent];
export const POWER_OVER_SPEED_DIAGRAM_CURVES = [CurveType.MotorShaftPower, CurveType.MotorShaftPowerWithSpecificVoltage, CurveType.LoadPower];
export const TIME_OVER_SPEED_DIAGRAM_CURVES = [CurveType.StartUpTime, CurveType.StartUpTimeWithSpecificVoltage, CurveType.StartUpTimeWithYD];
export const CURRENT_OVER_TIME_DIAGRAM_CURVES = [CurveType.CurrentOverTimeWithY, CurveType.CurrentOverTimeWithYWithSpecificVoltage, CurveType.CurrentOverTimeWithD, CurveType.CurrentOverTimeWithDWithSpecificVoltage, CurveType.CurrentOverTimeWithYD];
export const CONVERTER_OPERATION_VSD_DIAGRAM_CURVES = [CurveType.VsdTorqueLimit, CurveType.VsdPowerLimit];
